(function () {
  'use strict';

  var API_URL = 'https://shipping-estimate-six.vercel.app/api/shipping/calculate';
  var CACHE_KEY = 'shipping-estimate-dates';
  var CACHE_TTL_MS = 5 * 60 * 1000; // 5 minutos: suficiente para no pegar en cada navegación, y refleja cambios de feriados rápido

  var elOrderNow = document.getElementById('order_now');
  var elDelivered = document.getElementById('order_delivered');

  function safeStorage() {
    try {
      var probe = '__shipping_estimate_probe__';
      window.localStorage.setItem(probe, '1');
      window.localStorage.removeItem(probe);
      return window.localStorage;
    } catch (e) {
      return null; // navegadores en modo privado o storage bloqueado: solo fetch
    }
  }

  function readCache(storage) {
    if (!storage) return null;
    try {
      var raw = storage.getItem(CACHE_KEY);
      if (!raw) return null;
      var entry = JSON.parse(raw);
      if (!entry || typeof entry.data !== 'object') return null;
      if (Date.now() - entry.fetchedAt > CACHE_TTL_MS) {
        storage.removeItem(CACHE_KEY);
        return null;
      }
      return entry.data;
    } catch (e) {
      return null;
    }
  }

  function writeCache(storage, data) {
    if (!storage) return;
    try {
      storage.setItem(CACHE_KEY, JSON.stringify({ fetchedAt: Date.now(), data: data }));
    } catch (e) {
      /* cuota llena o storage bloqueado: sin cache, no es crítico */
    }
  }

  function render(data) {
    if (!data) return;
    if (elOrderNow && typeof data.order_date === 'string') {
      elOrderNow.textContent = data.order_date;
    }
    if (elDelivered && typeof data.order_delivered === 'string') {
      elDelivered.textContent = data.order_delivered;
    }
  }

  function hideBlocks() {
    if (elOrderNow) elOrderNow.textContent = '';
    if (elDelivered) elDelivered.textContent = '';
  }

  function fetchDates(storage) {
    return fetch(API_URL)
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.json();
      })
      .then(function (data) {
        render(data);
        writeCache(storage, data);
      });
  }

  var storage = safeStorage();
  var cached = readCache(storage);

  if (cached) {
    render(cached); // sin salto de layout y sin petición
  } else {
    fetchDates(storage).catch(function () {
      hideBlocks(); // API caída: no mostramos contenido incompleto
    });
  }
})();